import React from 'react';
import { HomeIcon, MapPinIcon } from 'lucide-react';
import type { PropertyContext } from '../../utils/propertyContext';
interface PropertyContextCardProps {
  context: PropertyContext;
  children?: React.ReactNode;
}
export function PropertyContextCard({
  context,
  children
}: PropertyContextCardProps) {
  return <div className="overflow-hidden rounded-3xl bg-white shadow-soft ring-1 ring-ink-200/70" data-id="element-564" data-mp="1dphbiqazwiyw">
      {context.photo ? <div className="relative aspect-[16/10]" data-id="element-565" data-mp="zpg7j1zfovf7">
          <img src={context.photo} alt={context.title} className="h-full w-full object-cover" data-id="element-566" data-mp="14qdqhgs9pthr" />
          <span className="absolute left-4 top-4 rounded-full bg-white/95 px-3 py-1 text-xs font-medium text-ink-900" data-id="element-567" data-mp="pt3gkbv9wvo5">{context.status}</span>
        </div> : <div className="flex items-center justify-between bg-pulse-50 px-5 py-5 md:px-6" data-id="element-568" data-mp="utr8czrbtgjf">
          <span className="grid h-11 w-11 place-items-center rounded-xl bg-white text-pulse-600 ring-1 ring-pulse-100" data-id="element-569" data-mp="2k4i72uw3yz4y">
            <HomeIcon className="h-5 w-5" aria-hidden data-id="element-570" data-mp="1mcvj1kzd3srh" />
          </span>
          <span className="rounded-full bg-white px-3 py-1 text-xs font-medium text-pulse-800" data-id="element-571" data-mp="1mb0xq5k6hymv">{context.status}</span>
        </div>}
      <div className="p-5 md:p-6" data-id="element-572" data-mp="1w2f0cm7ffek8">
        {context.location && <p className="flex items-center gap-1.5 text-sm text-ink-500" data-id="element-573" data-mp="1w4rfkrlsvatl">
            <MapPinIcon className="h-4 w-4" aria-hidden data-id="element-574" data-mp="1r4wsz09257ec" /> {context.location}
          </p>}
        <p className="mt-1 text-xl font-semibold tracking-tight text-ink-900" data-id="element-575" data-mp="13esqiw7lvdox">{context.title}</p>
        {context.subtitle && <p className="mt-0.5 text-[15px] text-ink-500" data-id="element-576" data-mp="ygr7uce3dgdz">{context.subtitle}</p>}
        <div className="mt-4 flex items-baseline justify-between rounded-xl bg-ink-50 px-4 py-3 text-sm" data-id="element-577" data-mp="1cfh1fi1pcxxl">
          <span className="text-ink-500" data-id="element-578" data-mp="18bj3vbs0zv6n">{context.detailLabel}</span>
          <span className="tabular font-medium text-ink-900" data-id="element-579" data-mp="2nt30buxd6dwb">{context.detailValue}</span>
        </div>
        {children && <div className="mt-6 border-t border-ink-100 pt-6" data-id="element-580" data-mp="2jrhgfpmewzcm">{children}</div>}
      </div>
    </div>;
}